module.exports = __webpack_public_path__ + "fonts/312128_0_0.woff2";